export default __webpack_public_path__ + "static/media/ungroup-objects.c9906c49.svg";